import { render, staticRenderFns } from "./SectionContainerPage.vue?vue&type=template&id=6b2fe29b"
import script from "./SectionContainerPage.vue?vue&type=script&lang=js"
export * from "./SectionContainerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports